import { photoUrl } from "@/lib/api";
import { Footprints } from "lucide-react";

export default function ProductThumb({ product, size = "w-10 h-10", testId }) {
  return (
    <div className={`${size} rounded-md border border-[#DCCFB8] bg-[#EFE6D6] overflow-hidden flex items-center justify-center shrink-0`}
      data-testid={testId}>
      {product?.photo_path
        ? <img src={photoUrl(product.photo_path)} alt={`${product.model_code} ${product.model_color}`} loading="lazy" className="w-full h-full object-cover" />
        : <Footprints className="w-1/2 h-1/2 text-[#A8977F]" />}
    </div>
  );
}
